import { CustomErrorType } from "../interfaces/CustomErrorType";

export default {
    code: 'ERR_CONNECTION_TIMEOUT',
    statusCode: 400,
    message: {
        en: 'Connection Timeout',
    },
} as CustomErrorType;